import { http, tenantHttp, type HttpClient } from './core/http-client';
import type {
  SupportListItem,
  SupportRequestDetail,
  SupportStatus,
  SupportTopicOption,
} from './models';

// Help page: a team member writes to Fairvero (tenant-scoped).
export class HelpService {
  constructor(private readonly http: HttpClient) {}

  topics = () => this.http.get<SupportTopicOption[]>('/business/support/topics');

  send = (b: { topic: string; subject?: string; message: string }) =>
    this.http.post<{ reference: string }>('/business/support', b);
}

// Staff inbox: platform staff only, behind two-step verification.
export class SupportInboxService {
  constructor(private readonly http: HttpClient) {}

  list = (status?: SupportStatus) =>
    this.http.get<SupportListItem[]>('/admin/support', { query: { status } });

  get = (id: string) => this.http.get<SupportRequestDetail>(`/admin/support/${id}`);

  reply = (id: string, message: string, close: boolean) =>
    this.http.post<SupportRequestDetail>(`/admin/support/${id}/replies`, { message, close });

  close = (id: string) => this.http.post<SupportRequestDetail>(`/admin/support/${id}/close`, {});
}

export const helpService = new HelpService(tenantHttp);
export const supportInboxService = new SupportInboxService(http);
